import { lazy, Suspense } from 'react';
import Loader from './Loader';
import PageNotFound from './PageNotFound';

const CampaignRegister = lazy(() => import('./CampaignRegister'));
const CampaignCollection = lazy(() => import('./CampaignCollection'));
const BookAppointment = lazy(() => import('./BookAppointment'));
const CancelBooking = lazy(() => import('./CancelBooking'));

const routes = [
    // Registration frontend routes
    {
        domain: /^(localhost:3000|((prod|pilot|nightly|prototyp|testing)-)?aktionen\.)/,
        route: /^\/aktion\/(\d+)-.+$/,
        render: (match) => <CampaignRegister campaignId={parseInt(match[1], 10)} />,
    },
    {
        domain: /^(localhost:3000|((prod|pilot|nightly|prototyp|testing)-)?aktionen\.)/,
        route: /^\/sammlung\/(\d+)-.+$/,
        render: (match) => <CampaignCollection campaignCollectionId={parseInt(match[1], 10)} />,
    },
    // Appointment frontend
    {
        domain: /^(localhost:3001|((prod|pilot|nightly|prototyp|testing)-)?termine\.)/,
        route: /^\/aktion\/(\d+)-.+$/,
        render: (match) => <BookAppointment campaignId={parseInt(match[1], 10)} />,
    },
    {
        domain: /^(localhost:3001|((prod|pilot|nightly|prototyp|testing)-)?termine\.)/,
        route: /^\/stornieren\/(\d+)\/([^/]+)$/,
        render: (match) => (
            <CancelBooking
                id={parseInt(match[1], 10)}
                cancellationKey={
                    // Cancellation key is url encoded
                    decodeURIComponent(match[2])
                }
            />
        ),
    },
];

const PageSelector = () => {
    const port = !window.location.port || ['80', '443'].includes(window.location.port)
        ? ''
        : `:${window.location.port}`;
    const domain = window.location.hostname + port;
    const path = window.location.pathname;
    for (const { domain: domainRegex, route, render } of routes) {
        if (!domain.match(domainRegex)) {
            // Skip route if domain regex does not match
            continue;
        }

        const match = path.match(route);
        if (match) {
            // Route matched, render it!
            return (
                <Suspense fallback={<Loader />}>
                    {render(match)}
                </Suspense>
            );
        }
    }

    // No route matched
    return <PageNotFound />;
};

export default PageSelector;
